import { Collections, User } from "api";
import { FormikHelpers } from "formik";
import { useSnackbar } from "notistack";
import { useContext } from "react";
import { useFirestore } from "react-redux-firebase";
import { LOGIN_ERROR_MESSAGES } from "redux/reducers/authReducer";
import { LoggedUserContext } from "ui/componentes";

export const useSaveUser = ({
    updatePrivateInfo = false,
    updateRoles = false,
}) => {
    const firestore = useFirestore();
    const { enqueueSnackbar } = useSnackbar();
    const loggedUser = useContext(LoggedUserContext);

    return async (values: User, { setSubmitting }: FormikHelpers<any>) => {
        const { id, privateInfo, roles, ...user } = values;
        setSubmitting(true);

        const writeBatch = firestore.batch();

        if (id === loggedUser.id || loggedUser.isAdmin) {
            const userRef = firestore.collection(Collections.USERS).doc(id);
            user.displayName = `${user.firstName} ${user.lastName}`;
            writeBatch.update(userRef, user);
        }

        if (updatePrivateInfo) {
            const privateInfoRef = firestore
                .collection(Collections.USERS_PRIVATE_INFO)
                .doc(id);
            writeBatch.update(privateInfoRef, privateInfo);
        }

        if (updateRoles) {
            const rolesRef = firestore
                .collection(Collections.USERS_ROLES)
                .doc(id);
            writeBatch.update(rolesRef, { roles });
        }

        writeBatch
            .commit()
            .then(() => {
                enqueueSnackbar("Dados salvos com sucesso!", {
                    variant: "success",
                });
                setSubmitting(false);
            })
            .catch((err) => {
                console.error(err);
                enqueueSnackbar(LOGIN_ERROR_MESSAGES["permission-denied"], {
                    variant: "error",
                });
                setSubmitting(false);
            });
    };
};
